import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=00137c5f&"
import script from "./TextAreaField.vue?vue&type=script&lang=js&"
export * from "./TextAreaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00137c5f')) {
      api.createRecord('00137c5f', component.options)
    } else {
      api.reload('00137c5f', component.options)
    }
    module.hot.accept("./TextAreaField.vue?vue&type=template&id=00137c5f&", function () {
      api.rerender('00137c5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/custom-fields/TextAreaField.vue"
export default component.exports